// CreatePost.js

import React, { useState, useEffect, useRef } from 'react';
import NewPostTags from './NewPostTags';
import LocationPicker from './LocationPicker';
import { getDatabase, ref, set, get, push } from 'firebase/database';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { LoadScript} from '@react-google-maps/api';
import {
    BrowserRouter as Router,

    Link,
 
  } from "react-router-dom";

function CreatePost({setShowCreatePostForm, showCreatePostForm, setShowFarmposts, showFarmposts, setIsLoading, isLoading}) {
    const [title, setTitle] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [description, setDescription] = useState('');
    const [image, setImage] = useState([null, null, null, null]);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedTags, setSelectedTags] = useState([]);
    const [pricingOption, setPricingOption] = useState('Free'); 
    const [selectedFileNames, setSelectedFileNames] = useState(['', '', '', '']);
    const [imagePreviews, setImagePreviews] = useState([null, null, null, null]); 
    const [postLocation, setPostLocation] = useState(null);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    
    const formRef = useRef(null);
    const autoCompleteRef = useRef(null);

    const possibleTitles = [
        "Apples",
        "Apricots",
        "Artichokes",
        "Arugula",
        "Asparagus",
        "Avocado",
        "Bananas",
        "Beans",
        "Beets",
        "Blackberries",
        "Blueberries",
        "Bok Choy",
        "Broccoli",
        "Brussels Sprouts",
        "Cabbage",
        "Cantaloupe",
        "Carrots",
        "Cauliflower",
        "Celery",
        "Chard",
        "Cherries",
        "Chili Peppers",
        "Chives",
        "Cilantro",
        "Citrus",
        "Coconut",
        "Corn",
        "Cranberries",
        "Cucumbers",
        "Currants",
        "Dates",
        "Dill",
        "Eggplant",
        "Endive",
        "Fennel",
        "Figs",
        "Garlic",
        "Ginger",
        "Grapefruit",
        "Grapes",
        "Green Beans",
        "Green Onions",
        "Guava",
        "Honeydew",
        "Horseradish",
        "Jicama",
        "Kale",
        "Kiwi",
        "Kohlrabi",
        "Leeks",
        "Lemons",
        "Lettuce",
        "Limes",
        "Lychee",
        "Mango",
        "Mint",
        "Mushrooms",
        "Nectarines",
        "Okra",
        "Onions",
        "Oranges",
        "Papaya",
        "Parsley",
        "Parsnips",
        "Passion Fruit",
        "Peaches",
        "Pears",
        "Peas",
        "Peppers",
        "Persimmons",
        "Pineapple",
        "Plums",
        "Pomegranate",
        "Potatoes",
        "Pumpkin",
        "Radicchio",
        "Radishes",
        "Raspberries",
        "Rhubarb",
        "Rosemary",
        "Rutabaga",
        "Sage",
        "Shallots",
        "Snap Peas",
        "Spinach",
        "Sprouts",
        "Squash",
        "Strawberries",
        "Sweet Potatoes",
        "Tangerines",
        "Taro",
        "Thyme",
        "Tomatillo",
        "Tomatoes",
        "Turnips",
        "Watercress",
        "Watermelon",
        "Winter Melon",
        "Yams",
        "Zucchini",
        "Barley",
        "Basil",
        "Black-Eyed Peas",
        "Capers",
        "Cardamom",
        "Cayenne Pepper",
        "Chard",
        "Chickpeas",
        "Cocoa Beans",
        "Coriander",
        "Cress",
        "Dandelion Greens",
        "Edamame",
        "Fava Beans",
        "Fenugreek",
        "Flaxseed",
        "Goji Berries",
        "Green Tea",
        "Jalapeno",
        "Lavender",
        "Lentils",
        "Mace",
        "Maize",
        "Millet",
        "Moringa",
        "Mulberries",
        "Mustard Greens",
        "Nutmeg",
        "Oats",
        "Olives",
        "Oregano",
        "Paprika",
        "Peanuts",
        "Pecans",
        "Pistachios",
        "Poppy Seeds",
        "Quinoa",
        "Raisins",
        "Rye",
        "Saffron",
        "Sesame Seeds",
        "Sorghum",
        "Soybeans",
        "Spelt",
        "Starfruit",
        "Sunflower Seeds",
        "Tapioca",
        "Turmeric",
        "Ugli Fruit",
        "Vanilla",
        "Walnuts",
        "Wheat"
    ];
    


    const possibleTags = [
        "organic", "you-pick", "washed",
         "pesticide-free", "non-GMO",
        "heirloom", "harvested",
        "locally-sourced", "permaculture", "biodynamic",
        "seasonal"
    ];

    const auth = getAuth();
    const userId = auth.currentUser ? auth.currentUser.uid : null;

    //this function pays attention to which tags have been selected by the user, and then adds those tags to the post when they create the post.
    const toggleTag = (tag) => {
        setSelectedTags(prevTags => {
            if (prevTags.includes(tag)) {
                // If tag is already selected, remove it
                return prevTags.filter(t => t !== tag);
            } else {
                // Otherwise, add it
                return [...prevTags, tag];
            }
        });
    };

      const handleLocationSelected = (location) => {
    setPostLocation(location);
    console.log(postLocation);
  };
    
        // const cancelCreatePost = () => {
        //     // Reset all form state to its initial state
        //     setTitle('');
        //     setSuggestions([]);
        //     setDescription('');
        //     setImage([null, null, null, null]);
        //     setErrorMessage('');
        //     setSelectedTags([]);
        //     setPricingOption('Free');
        //     setSelectedFileNames(['', '', '', '']);
        //     setImagePreviews([null, null, null, null]);
        
        //     // Hide the CreatePost form
        //     setShowCreatePostForm(false);
        //     setShowFarmposts(true);
        // };
  


    const handleTitleChange = (e) => {
        const value = e.target.value;
        setIsLoading(true);
        setTitle(value);

        if (value.length > 2) {
            const filteredSuggestions = possibleTitles.filter(title =>
                title.toLowerCase().includes(value.toLowerCase())
            );
            setSuggestions(filteredSuggestions);
            setIsLoading(false);
        } else {
            setSuggestions([]);
            setIsLoading(false);
        }
    };

    const selectSuggestion = (suggestion) => {
        setTitle(suggestion);
        setSuggestions([]); // clear suggestions once one is selected
    };

    // //this function changes the image that was selected by the user
    // const handleImageChange = (index, e) => {
    //     const file = e.target.files[0];
    //     setImage(prevImages => {
    //         const newImages = [...prevImages];
    //         newImages[index] = file;
    //         return newImages;
    //     });
    // };


    //resizes and compresses the image before storing
    function resizeImage(file, maxWidth, maxHeight) {
        return new Promise((resolve, reject) => {
            if (!(file instanceof File)) {
                reject('Not a valid file');
                return;
            }
    
            const image = new Image();
            image.src = URL.createObjectURL(file);
    
            image.onload = () => {
                const canvas = document.createElement('canvas');
                const aspectRatio = image.width / image.height;
    
                let newWidth = image.width;
                let newHeight = image.height;
    
                if (image.width > image.height) {
                    // Width is the larger dimension
                    newWidth = maxWidth;
                    newHeight = maxWidth / aspectRatio;
                } else {
                    // Height is the larger dimension or they are equal
                    newHeight = maxHeight;
                    newWidth = maxHeight * aspectRatio;
                }
    
                canvas.width = newWidth;
                canvas.height = newHeight;
    
                const ctx = canvas.getContext('2d');
                ctx.drawImage(image, 0, 0, newWidth, newHeight);
                
                canvas.toBlob((blob) => {
                    resolve(blob);
                }, 'image/jpeg', 0.8);
            };
    
            image.onerror = reject;
        });
    }


//workaround to hide the ugly default choose file button for the image selector
const handleFileInputChange = (index, event) => {
    const file = event.target.files[0];
    if (file) {
        // Update selectedFileNames state
        const newFileNames = [...selectedFileNames];
        newFileNames[index] = file.name;
        setSelectedFileNames(newFileNames);

        // Store the actual file in the image state
        const updatedImages = [...image];
        updatedImages[index] = file;
        setImage(updatedImages);

        // Read the file and set its URL in the imagePreviews state
        const reader = new FileReader();
        reader.onload = (e) => {
            const newPreviews = [...imagePreviews];
            newPreviews[index] = e.target.result;
            setImagePreviews(newPreviews);
        };
        reader.readAsDataURL(file);
    }
};

    //stores the posts images to the firebase storage bucket
    const uploadImagesAndGetURLs = async () => {
        const storage = getStorage();
        const promises = image.map(async (img, index) => {
            if (img) {
                const resizedBlob = await resizeImage(img, 400, 600);
                const storagePath = `farmpost-images/${Date.now()}-${userId}-${img.name}`;
                const imageRef = storageRef(storage, storagePath);
                
                await uploadBytes(imageRef, resizedBlob);
                return getDownloadURL(imageRef);
            }
            return null; // return null for the images that were not provided by the user
        });
        return Promise.all(promises).then(urls => urls.filter(url => url)); // filter out null values
    };

    
  useEffect(() => {
    const fetchUserLocation = async () => {
        setIsLoading(true);
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        const db = getDatabase();
        const userRef = ref(db, `users/${user.uid}`);
        
        const snapshot = await get(userRef);
        setIsLoading(false);

        if (snapshot.exists() && snapshot.val().location) {
          setPostLocation(snapshot.val().location);
          setIsLoading(false);
        }
      }
    };
    
    fetchUserLocation();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const auth = getAuth();
    if (!auth.currentUser) {
        setErrorMessage('Only logged in users can post.');
        setIsLoading(false);
        setTimeout(() => {
            setErrorMessage(null);  // Clear the error message after 3 seconds
        }, 3000); 
        return;
    }

    if (!postLocation) {
        setErrorMessage('Please select a location for the post.');
        setIsLoading(false);
        setTimeout(() => {
            setErrorMessage(null);  // Clear the error message after 3 seconds
        }, 3000); 
        return;
    }

    const db = getDatabase();
    const userRef = ref(db, `users/${auth.currentUser.uid}`);
    const snapshot = await get(userRef);
    const username = snapshot.val() ? snapshot.val().username : null;

    if (!username) {
        setErrorMessage('Username not found. Please set your username first.');
        setIsLoading(false);
        setTimeout(() => {
            setErrorMessage(null);  // Clear the error message after 3 seconds
        }, 3000); 
        return;
    }

    const downloadURLs = await uploadImagesAndGetURLs();

    if (downloadURLs.length < 2) {
        setErrorMessage('Must add at least two images.');
        setIsLoading(false);
        setTimeout(() => {
            setErrorMessage(null);  // Clear the error message after 3 seconds
        }, 3000); 
        return;
    }

    // If all checks pass, show the confirmation modal
    setShowConfirmationModal(true);
    setIsLoading(false);
}

const handleConfirmedSubmission = async () => {
    setIsLoading(true);
    setShowConfirmationModal(false);

    const db = getDatabase();
    const auth = getAuth();
    const userRef = ref(db, `users/${auth.currentUser.uid}`);
    const snapshot = await get(userRef);
    const username = snapshot.val() ? snapshot.val().username : null;
    
    // Assuming uploadImagesAndGetURLs is idempotent (produces the same result when called multiple times with the same input)
    const downloadURLs = await uploadImagesAndGetURLs();

        // Save post data to the database
        const newPostRef = push(ref(db, 'farmposts'));
        await set(newPostRef, {
            title,
            description,
            imageUrls: downloadURLs,  
            uid: auth.currentUser.uid,
            username,  
            timestamp: Date.now(),
            tags: selectedTags,
            pricing: pricingOption,
            location: {
                lat: postLocation.lat,
                lng: postLocation.lng
            }
        });
        // Reset the form and location
        
        setTitle('');
        setDescription('');
        setImage([null, null, null, null]);
        setSelectedTags([]);
        setSuggestions([]);
        setPostLocation(null);  // Reset the location state
        setShowFarmposts(true);
        setShowCreatePostForm(false);
        setIsLoading(false);
    }
    
    console.log("error",errorMessage);

    return (
        <div className="create_post_sizer">
        <div className="create_post_container">

        {showConfirmationModal && (
            <div className="modal_overlay">
                <div className="modal_overlay">
                    <div className="create_post_rules">
                <div className="create_post_rules_header">By posting, you're agreeing to some ground rules:</div>
                <div className="create_post_rules_item">1. Don't be gross</div>
                <div className="create_post_rules_text">Posts & pictures should be wholesome and family-friendly.</div>
                <div className="create_post_rules_item">2. Don't be mean</div>
                <div className="create_post_rules_text">Harassing the gardeners will not be tolerated.</div>
                <div className="create_post_rules_item">3. Don't be scary</div>
                <div className="create_post_rules_text">Anything that would frighten a child counts.</div>
                <div className="create_post_rules_item">4. Don't be a criminal</div>
                <div className="create_post_rules_text">This isn't the silk road, you'll probably get caught.</div>
                <div className="create_post_rules_text_footer">If you break these rules, you won't be allowed to post.</div>
                <Link to="/"><button className="create_post_rules_submit_button" onClick={handleConfirmedSubmission}>Agree & Post</button></Link>
                <button className="create_post_rules_cancel_button" onClick={() => {setShowConfirmationModal(false)}}>Actually, nevermind...</button>
                </div>
                </div>
            </div>
        )}
            <div className="create_post_label_header_top">Create a New Post</div>
        <form ref={formRef} onSubmit={handleSubmit}>
        <div className="create_post_autocomplete_container" ref={autoCompleteRef}>
            <input
                className="create_post_title_input"
                type="text"
                maxLength="30"
                placeholder="What does your garden grow?"
                value={title}
                onChange={handleTitleChange}
                required
            />

            <ul className="create_post_suggestions_list">
                {suggestions.map((suggestion, index) => (
                    <li className="create_post_suggestions_list_item" key={index} onClick={() => selectSuggestion(suggestion)}>
                        {suggestion}
                    </li>
                ))}
            </ul>
            </div>
            {/* <input type="text" placeholder="Title" value={title} onChange={e => setTitle(e.target.value)} required /> */}



            <textarea maxLength="280" className="create_post_description" placeholder="Description" value={description} onChange={e => setDescription(e.target.value)} required></textarea>
            <div className="create_post_pricing_toggle_container">
        <label className="create_post_pricing_toggle">
            <input 
                        
                type="radio" 
                value="Free" 
                checked={pricingOption === 'Free'} 
                onChange={e => setPricingOption(e.target.value)} 
            />
            Free
        </label>
        <label className="create_post_pricing_toggle">
            <input 
                type="radio" 
                value="Trade" 
                checked={pricingOption === 'Trade'} 
                onChange={e => setPricingOption(e.target.value)} 
            />
            Trade
        </label></div>
            <div className="create_post_label_header">Please add 2 - 4 images to your post</div>
<div className="create_post_image_uploader_container">
{[0, 1, 2, 3].map(index => (
    <div key={index}>
        <label 
            htmlFor={`fileInput-${index}`} 
            className="create_post_custom_file_upload" 
            style={{ backgroundImage: `url(${imagePreviews[index]})` }} // <-- Use the image as the background
        >
             {selectedFileNames[index] ? "" : "Add Image"}
        </label>
        <input
            className="create_post_image_select"
            id={`fileInput-${index}`}
            type="file"
            onChange={(e) => handleFileInputChange(index, e)}
            // required={index < 2}
        />
        <div className="create_post_selected_image_filenames">{selectedFileNames[index]}</div>
    </div>
))}</div>
<div className="create_post_label_header" >Add tags (optional)</div>
            <div className="create_post_tags">
              {possibleTags.map(tag => (
                    <NewPostTags 
                        key={tag} 
                        name={tag} 
                        isSelected={selectedTags.includes(tag)}
                        toggleTag={toggleTag}
                    />
                ))}</div>
                <div className="create_post_label_header">Location <br></br> (posts will only display distances)</div>
                
<LocationPicker onLocationSelected={handleLocationSelected} />
<div className="create_post_disclaimer_message">By posting, you agree to the terms and conditions.</div>
<div className="create_post_submit_post_button_container">
{errorMessage && <div className="create_post_error_message">{errorMessage ? errorMessage : ""}</div>}

            <button style={isLoading ? { opacity: 0.5 } : {}} disabled={isLoading} className="create_post_submit_post_button" type="submit">Post</button></div>
        </form>
       
    </div></div>
    );
}

export default CreatePost;
